import React from 'react';
export default function About(){
  return (
    <section id="about" className="section">
      <div className="container">
        <h2>About LongRange Security</h2>
        <p>We secure digital infrastructure, networks, and data systems from the code to the cloud.
Our mission is to make cybersecurity accessible, intelligent, and relevant to the realities of Africa.

LongRange is built on resilience, precision, integrity, innovation, and local awareness.
We don’t just stop attacks, we prepare you for the ones no one sees coming.</p>
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(200px,1fr))',gap:12,marginTop:18}}>
          <div className="card"><h4>Vision</h4><p>To fortify Africa’s digital frontier so people and businesses can create and move online without fear.</p></div>
          <div className="card"><h4>Mission</h4><p>To make cybersecurity accessible, intelligent, and relevant to the realities of Africa.</p></div>
          <div className="card"><h4>Values</h4><p>Resilience • Precision • Integrity • Innovation • Local Awareness</p></div>
        </div>
      </div>
    </section>
  );
}
